import React, { useState, useEffect } from "react";
import "../components/LibroReclamaciones.css"; // Asegúrate de tener este archivo CSS
import "@fortawesome/fontawesome-free/css/all.min.css"; // Importa los estilos de FontAwesome
import { db } from "../components/firebase";
import {
  collection,
  query,
  orderBy,
  limit,
  getDocs,
  addDoc,
} from "firebase/firestore";
import emailjs from "@emailjs/browser";
import jsPDF from "jspdf";
import logoPrimus from "../assets/img/LOGO_PRIMUS_300X64.png";

const LibroReclamaciones = () => {
  const fechaActual = new Date().toLocaleDateString("es-PE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const [formData, setFormData] = useState({
    razonSocial: "",
    nombres: "",
    apellidos: "",
    tipoDocumento: "",
    numeroDocumento: "",
    domicilio: "",
    correo: "",
    telefono: "",
    esMenorDeEdad: false,
    nombreApoderado: "",
    domicilioApoderado: "",
    telefonoApoderado: "",
    correoApoderado: "",
    tipoBien: "",
    montoBien: "",
    moneda: "",
    descripcion: "",
    tipoReclamo: "",
    detalle: "",
    pedido: "",
    obsProveedor: "",
  });

  const [mostrarResumen, setMostrarResumen] = useState(false);
  const [idReclamacion, setIdReclamacion] = useState("");

  // Función para generar el ID al cargar la página
  useEffect(() => {
    const generarIdReclamacion = async () => {
      try {
        // Obtener el último ID de la colección "reclamaciones"
        const reclamacionesRef = collection(db, "reclamaciones");
        const q = query(
          reclamacionesRef,
          orderBy("idReclamacion", "desc"),
          limit(1)
        );
        const querySnapshot = await getDocs(q);

        const lastId = querySnapshot.empty
          ? 0
          : parseInt(querySnapshot.docs[0].data().idReclamacion, 10);

        // Generar el nuevo ID correlativo
        const newId = String(lastId + 1).padStart(6, "0");
        setIdReclamacion(newId); // Actualizar el estado con el nuevo ID
      } catch (error) {
        console.error("Error al generar el ID de reclamación:", error);
      }
    };

    generarIdReclamacion(); // Llamar a la función al cargar el componente
  }, []); // El array vacío asegura que se ejecute solo una vez al montar el componente

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleGuardarEnviar = async (e) => {
    e.preventDefault();

    try {
      // Obtener el último ID de la colección "reclamaciones"
      const reclamacionesRef = collection(db, "reclamaciones"); // colección
      const q = query(
        reclamacionesRef,
        orderBy("idReclamacion", "desc"),
        limit(1)
      ); // último docto
      const querySnapshot = await getDocs(q);

      const lastId = querySnapshot.empty
        ? 0
        : parseInt(querySnapshot.docs[0].data().idReclamacion, 10);

      // Generar el nuevo ID correlativo
      const newId = String(lastId + 1).padStart(6, "0");
      setIdReclamacion(newId);

      // Guardar en Firestore
      await addDoc(reclamacionesRef, {
        ...formData,
        idReclamacion: newId,
        fecha: fechaActual,
      });

     
      // Enviar correo con EmailJS
      const emailParams = {
        idReclamacion: newId,
        fecha: fechaActual,
        ...formData,
      };

      emailjs
        .send(
          process.env.REACT_APP_SERVICE_ID_RECLAMACION, // ID del servicio
          process.env.REACT_APP_TEMPLATE_ID_RECLAMACION, // ID de la plantilla
          emailParams, // Parámetros del correo
          process.env.REACT_APP_USER_ID_RECLAMACION // ID del usuario
        )
        .then(
          (result) => {
            console.log("Correo enviado:", result.text);
          },
          (error) => {
            console.error("Error al enviar el correo:", error);
          }
        );

      // Mostrar resumen
      setMostrarResumen(true);
    } catch (error) {
      console.error("Error al guardar o enviar:", error);
    }
  };

  const handleCancelar = async () => {
    setFormData({
      razonSocial: "",
      nombres: "",
      apellidos: "",
      tipoDocumento: "",
      numeroDocumento: "",
      domicilio: "",
      correo: "",
      telefono: "",
      tipoBien: "",
      montoBien: "",
      moneda: "",
      descripcion: "",
      tipoReclamo: "",
      detalle: "",
      pedido: "",
      esMenorDeEdad: false,
      nombreApoderado: "",
      domicilioApoderado: "",
      telefonoApoderado: "",
      correoApoderado: "",
    });
    setMostrarResumen(false);
    try {
      const reclamacionesRef = collection(db, "reclamaciones");
      const q = query(
        reclamacionesRef,
        orderBy("idReclamacion", "desc"),
        limit(1)
      );
      const querySnapshot = await getDocs(q);

      const lastId = querySnapshot.empty
        ? 0
        : parseInt(querySnapshot.docs[0].data().idReclamacion, 10);

      const newId = String(lastId + 1).padStart(6, "0");
      setIdReclamacion(newId); // Actualizar el estado con el nuevo ID
    } catch (error) {
      console.error("Error al generar el nuevo ID de reclamación:", error);
    }
  };

  // Función para generar el PDF
  const handleDescargarPDF = () => {
    const pdf = new jsPDF();

    // Agregar el logo en la esquina superior izquierda
    const logoWidth = 70; // Ancho del logo en mm
    const logoHeight = 15; // Alto del logo en mm
    pdf.addImage(logoPrimus, "PNG", 10, 10, logoWidth, logoHeight); // (imagen, formato, x, y, ancho, alto)

    // Título del documento
    pdf.setFontSize(16);
    pdf.text("Reclamación Primus Capital Perú", 105, 35, { align: "center" });

    // Información del formulario
    pdf.setFontSize(12);
    let yPosition = 50; // Posición inicial en el eje Y
    const lineSpacing = 10; // Espaciado entre líneas
    const pageHeight = 297; // Altura de la página en mm (A4)

    const addTextWithPagination = (text, x, y, maxWidth) => {
      const lines = pdf.splitTextToSize(text, maxWidth);
      lines.forEach((line) => {
        if (y > pageHeight - 20) {
          // Si se excede el espacio disponible en la página
          pdf.addPage(); // Crear una nueva página
          y = 20; // Reiniciar la posición Y en la nueva página
        }
        pdf.text(line, x, y);
        y += lineSpacing;
      });
      return y; // Retornar la posición Y actualizada
    };
    pdf.setFont("helvetica", "bold");
    pdf.text("Número de Reclamación:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    pdf.text(idReclamacion, 70, yPosition);
    yPosition += lineSpacing;
    pdf.setFont("helvetica", "bold");
    pdf.text("Fecha:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    pdf.text(fechaActual, 70, yPosition);
    yPosition += lineSpacing;

    // Datos del cliente
    pdf.setFont("helvetica", "bold");
    pdf.text("1. Identificación del Consumidor Reclamante:", 10, yPosition);
    yPosition += lineSpacing;

    pdf.setFont("helvetica", "bold");
    pdf.text("Razón Social:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(formData.razonSocial, 70, yPosition, 130);

    pdf.setFont("helvetica", "bold");
    pdf.text("Nombres:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(formData.nombres, 70, yPosition, 130);

    pdf.setFont("helvetica", "bold");
    pdf.text("Apellidos:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(formData.apellidos, 70, yPosition, 130);

    pdf.setFont("helvetica", "bold");
    pdf.text("Tipo de Documento:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(
      formData.tipoDocumento,
      70,
      yPosition,
      130
    );

    pdf.setFont("helvetica", "bold");
    pdf.text("Número de Documento:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(
      formData.numeroDocumento,
      70,
      yPosition,
      130
    );

    pdf.setFont("helvetica", "bold");
    pdf.text("Domicilio:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(formData.domicilio, 70, yPosition, 130);

    pdf.setFont("helvetica", "bold");
    pdf.text("Correo Electrónico:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(formData.correo, 70, yPosition, 130);

    pdf.setFont("helvetica", "bold");
    pdf.text("Teléfono:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(formData.telefono, 70, yPosition, 130);

    // Información del apoderado si aplica
    if (formData.esMenorDeEdad) {
      pdf.setFont("helvetica", "bold");
      pdf.text("Información del Apoderado:", 10, yPosition);
      yPosition += lineSpacing;

      pdf.setFont("helvetica", "bold");
      pdf.text("Nombre del Apoderado:", 10, yPosition);
      pdf.setFont("helvetica", "normal");
      yPosition = addTextWithPagination(
        formData.nombreApoderado,
        70,
        yPosition,
        130
      );

      pdf.setFont("helvetica", "bold");
      pdf.text("Domicilio del Apoderado:", 10, yPosition);
      pdf.setFont("helvetica", "normal");
      yPosition = addTextWithPagination(
        formData.domicilioApoderado,
        70,
        yPosition,
        130
      );

      pdf.setFont("helvetica", "bold");
      pdf.text("Teléfono del Apoderado:", 10, yPosition);
      pdf.setFont("helvetica", "normal");
      yPosition = addTextWithPagination(
        formData.telefonoApoderado,
        70,
        yPosition,
        130
      );

      pdf.setFont("helvetica", "bold");
      pdf.text("Correo del Apoderado:", 10, yPosition);
      pdf.setFont("helvetica", "normal");
      yPosition = addTextWithPagination(
        formData.correoApoderado,
        70,
        yPosition,
        130
      );
    } else {
      pdf.setFont("helvetica", "bold");
      pdf.text("Es Menor de Edad:", 10, yPosition);
      pdf.setFont("helvetica", "normal");
      yPosition = addTextWithPagination("No", 70, yPosition, 130);
    }

    // Información del bien
    pdf.setFont("helvetica", "bold");
    pdf.text("2. Identificación del bien contratado:", 10, yPosition);
    yPosition += lineSpacing;

    pdf.setFont("helvetica", "bold");
    pdf.text("Tipo de Bien:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(formData.tipoBien, 70, yPosition, 130);

    pdf.setFont("helvetica", "bold");
    pdf.text("Monto del Bien Contratado:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(
      `${formData.moneda} ${formData.montoBien} - Descripción: ${formData.descripcion}`,
      70,
      yPosition,
      130
    );

    // Información del reclamo
    pdf.setFont("helvetica", "bold");
    pdf.text(
      "3. Detalle de la Reclamación y Pedido del Consumidor:",
      10,
      yPosition
    );
    yPosition += lineSpacing;

    pdf.setFont("helvetica", "bold");
    pdf.text("Detalle:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(formData.detalle, 70, yPosition, 130);

    pdf.setFont("helvetica", "bold");
    pdf.text("Pedido:", 10, yPosition);
    pdf.setFont("helvetica", "normal");
    yPosition = addTextWithPagination(formData.pedido, 70, yPosition, 130);

    // Descarga el archivo PDF
    pdf.save(`Reclamacion_${idReclamacion}.pdf`);
  };
  return (
    <div className="libro-reclamaciones-container">
      <div className="form-containerRec">
        <div className="containerTitleRec">
          <h1 className="form-titleRec tituloReclamacion">
            <i className="fas fa-book-open form-iconRec "></i> Libro de
            Reclamaciones
          </h1>
        </div>
        <div className="form-dateRec">
          <div className="date-item">
            <label htmlFor="fecha">Fecha:</label>
            <input
              type="text"
              id="fecha"
              value={fechaActual}
              disabled
              className="input-disabled"
            />
          </div>
          {!mostrarResumen && ( // Esconde "Reclamación Nro" si se está mostrando el resumen
            <div className="date-item">
              <label htmlFor="idReclamacion">Reclamación Nro:</label>
              <input
                type="text"
                id="idReclamacion"
                value={idReclamacion || "---"}
                disabled
                className="input-disabled"
              />
            </div>
          )}
        </div>
        {!mostrarResumen ? (
          <>
            <form className="reclamaciones-form" onSubmit={handleGuardarEnviar}>
              <div className="form-groupRec">
                <label htmlFor="razonSocial">
                  Razón Social de la Persona Jurídica:
                </label>
                <select
                  id="razonSocial"
                  name="razonSocial"
                  value={formData.razonSocial}
                  onChange={handleInputChange}
                >
                  <option value="">Seleccione</option>
                  <option value="PRIMUS CAPITAL PERÚ S.A.C. RUC 20602253873 Av.Jorge Basadre 233, Piso 5, San Isidro, Lima, Perú">
                    PRIMUS CAPITAL PERÚ S.A.C. RUC 20602253873 Av.Jorge Basadre
                    233, Piso 5, San Isidro, Lima, Perú
                  </option>
                  <option value="PRIMUS CAPITAL CRÉDITOS S.A.C. RUC 20604262250  Av.Jorge Basadre 233, Piso 5, San Isidro, Lima, Perú">
                    PRIMUS CAPITAL CRÉDITOS S.A.C. RUC 20604262250 Av.Jorge
                    Basadre 233, Piso 5, San Isidro, Lima, Perú
                  </option>
                  <option value="PRIMUS CAPITAL ADMINISTRADORA DE ACTIVOS S.A.C. RUC 20608121065 Av.Jorge Basadre 233, Piso 5, San Isidro, Lima, Perú">
                    PRIMUS CAPITAL ADMINISTRADORA DE ACTIVOS S.A.C. RUC
                    20608121065 Av.Jorge Basadre 233, Piso 5, San Isidro, Lima,
                    Perú
                  </option>
                  <option value="PRIMUS CAPITAL LEASING S.A.C. RUC 20607258245 Av.Jorge Basadre 233, Piso 5, San Isidro, Lima, Perú">
                    PRIMUS CAPITAL LEASING S.A.C. RUC 20607258245 Av.Jorge
                    Basadre 233, Piso 5, San Isidro, Lima, Perú
                  </option>
                </select>
              </div>
              <h2>1. Identificación del Consumidor Reclamante</h2>
              <div className="form-rowRec">
                <div className="form-groupRec">
                  <label htmlFor="nombres">Nombres:</label>
                  <input
                    type="text"
                    id="nombres"
                    name="nombres"
                    value={formData.nombres}
                    onChange={handleInputChange}
                    placeholder="Ingrese sus nombres"
                  />
                </div>
                <div className="form-groupRec">
                  <label htmlFor="apellidos">Apellidos:</label>
                  <input
                    type="text"
                    id="apellidos"
                    name="apellidos"
                    value={formData.apellidos}
                    onChange={handleInputChange}
                    placeholder="Ingrese sus apellidos"
                  />
                </div>
              </div>
              <div className="form-rowRec">
                <div className="form-groupRec">
                  <label htmlFor="tipoDocumento">Tipo de Documento:</label>
                  <select
                    id="tipoDocumento"
                    name="tipoDocumento"
                    value={formData.tipoDocumento}
                    onChange={handleInputChange}
                  >
                    <option value="">Seleccione</option>
                    <option value="DNI">DNI</option>
                    <option value="CE">CE</option>
                    <option value="Pasaporte">Pasaporte</option>
                  </select>
                </div>
                <div className="form-groupRec">
                  <label htmlFor="numeroDocumento">Número de Documento:</label>
                  <input
                    type="text"
                    id="numeroDocumento"
                    name="numeroDocumento"
                    value={formData.numeroDocumento}
                    onChange={handleInputChange}
                    placeholder="Ingrese su número de documento"
                  />
                </div>
              </div>
              <div className="form-rowRec">
                <div className="form-groupRec">
                  <label htmlFor="domicilio">Domicilio:</label>
                  <input
                    type="text"
                    id="domicilio"
                    name="domicilio"
                    value={formData.domicilio}
                    onChange={handleInputChange}
                    placeholder="Ingrese su domicilio"
                  />
                </div>
                <div className="form-groupRec">
                  <label htmlFor="correo">Correo Electrónico:</label>
                  <input
                    type="email"
                    id="correo"
                    name="correo"
                    value={formData.correo}
                    onChange={handleInputChange}
                    placeholder="Ingrese su correo electrónico"
                  />
                </div>
                <div className="form-groupRec">
                  <label htmlFor="telefono">Teléfono/Celular:</label>
                  <input
                    type="tel"
                    id="telefono"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleInputChange}
                    placeholder="Ingrese su teléfono o celular"
                  />
                </div>
              </div>
              <div className="form-groupRec-checkbox">
                <input
                  type="checkbox"
                  id="esMenorDeEdad"
                  name="esMenorDeEdad"
                  checked={formData.esMenorDeEdad}
                  onChange={handleInputChange}
                />
                <label htmlFor="esMenorDeEdad">Soy menor de edad</label>
              </div>
              {formData.esMenorDeEdad && (
                <div className="form-apoderado">
                  <h3>Información del Apoderado:</h3>
                  <div className="form-rowRec">
                    <div className="form-groupRec">
                      <label htmlFor="nombreApoderado">
                        Nombre Completo del Apoderado:
                      </label>
                      <input
                        type="text"
                        id="nombreApoderado"
                        name="nombreApoderado"
                        value={formData.nombreApoderado}
                        onChange={handleInputChange}
                        placeholder="Ingrese el nombre completo del apoderado"
                      />
                    </div>
                    <div className="form-groupRec">
                      <label htmlFor="domicilioApoderado">
                        Domicilio Apoderado:
                      </label>
                      <input
                        type="text"
                        id="domicilioApoderado"
                        name="domicilioApoderado"
                        value={formData.domicilioApoderado}
                        onChange={handleInputChange}
                        placeholder="Ingrese el domicilio del apoderado"
                      />
                    </div>{" "}
                  </div>
                  <div className="form-rowRec">
                    <div className="form-groupRec">
                      <label htmlFor="telefonoApoderado">
                        Teléfono Apoderado:
                      </label>
                      <input
                        type="text"
                        id="telefonoApoderado"
                        name="telefonoApoderado"
                        value={formData.telefonoApoderado}
                        onChange={handleInputChange}
                        placeholder="Ingrese el número de teléfono del apoderado"
                      />
                    </div>
                    <div className="form-groupRec">
                      <label htmlFor="correoApoderado">Correo Apoderado:</label>
                      <input
                        type="text"
                        id="correoApoderado"
                        name="correoApoderado"
                        value={formData.correoApoderado}
                        onChange={handleInputChange}
                        placeholder="Ingrese el correo electrónico del apoderado"
                      />
                    </div>
                  </div>
                </div>
              )}
              <h2>2. Identificación del Bien Contratado</h2>
              <div className="form-rowRec">
                <div className="form-groupRec">
                  <label>Tipo de Bien:</label>
                  <div className="radio-group">
                    <div className="radio-item">
                      <input
                        type="radio"
                        id="producto"
                        name="tipoBien"
                        value="Producto"
                        checked={formData.tipoBien === "Producto"}
                        onChange={handleInputChange}
                      />
                      <label
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginRight: "1rem",
                          marginBottom: "0px",
                        }}
                        htmlFor="producto"
                      >
                        Producto
                      </label>
                    </div>
                    <div className="radio-item">
                      <input
                        type="radio"
                        id="servicio"
                        name="tipoBien"
                        value="Servicio"
                        checked={formData.tipoBien === "Servicio"}
                        onChange={handleInputChange}
                      />
                      <label
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginRight: "1rem",
                          marginBottom: "0px",
                        }}
                        htmlFor="servicio"
                      >
                        Servicio
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-rowRec">
                <div className="form-groupRec">
                  <label htmlFor="montoBien">Monto del Bien Contratado:</label>
                  <div className="form-groupRec-monto">
                    {/* Radio buttons para seleccionar la moneda */}
                    <div className="radio-group">
                    <div className="radio-item">
                      <input
                        type="radio"
                        id="pen"
                        name="moneda"
                        style={{ marginRight: "4px", verticalAlign: "middle" }}
                        value="PEN"
                        checked={formData.moneda === "PEN"}
                        onChange={handleInputChange}
                      />
                      <label
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginRight: "1rem",
                          marginBottom: "0px",
                        }}
                        htmlFor="pen"
                      >
                        PEN
                      </label>
                    </div>
                    <div className="radio-item">
                      <input
                        type="radio"
                        id="usd"
                        name="moneda"
                        style={{ marginRight: "4px", verticalAlign: "middle" }}
                        value="USD"
                        checked={formData.moneda === "USD"}
                        onChange={handleInputChange}
                      />
                      <label
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginRight: "1rem",
                          marginBottom: "0px",
                        }}
                        htmlFor="usd"
                      >
                        USD
                      </label>
                    </div>
                    </div>
                    {/* Input para ingresar el monto */}
                    <input
                      type="text"
                      id="montoBien"
                      name="montoBien"
                      value={formData.montoBien}
                      onChange={handleInputChange}
                      placeholder="Ingrese el monto del bien contratado"
                    />
                    <input
                      type="text"
                      id="descripcion"
                      name="descripcion"
                      value={formData.descripcion}
                      onChange={handleInputChange}
                      placeholder="Ingrese Descripción"
                    />
                  </div>
                </div>
              </div>
              <h2>3. Detalle de la Reclamación y Pedido del Consumidor</h2>
              <div className="form-rowRec">
                <div className="form-groupRec">
                  <label>Tipo de Reclamo:</label>
                  <div className="radio-group">
                    <div className="radio-item">
                      <input
                        type="radio"
                        id="reclamo"
                        name="tipoReclamo"
                        value="Reclamo"
                        checked={formData.tipoReclamo === "Reclamo"}
                        onChange={handleInputChange}
                      />
                      <label
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginRight: "1rem",
                          marginBottom: "0px",
                        }}
                        htmlFor="reclamo"
                      >
                        Reclamo<sup>1</sup>
                      </label>
                    </div>
                    <div className="radio-item">
                      <input
                        type="radio"
                        id="queja"
                        name="tipoReclamo"
                        value="Queja"
                        checked={formData.tipoReclamo === "Queja"}
                        onChange={handleInputChange}
                      />
                      <label
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          marginRight: "1rem",
                          marginBottom: "0px",
                        }}
                        htmlFor="queja"
                      >
                        Queja<sup>2</sup>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <p className="form-infoRec">
                <sup>1</sup> Reclamo: Disconformidad relacionada a los productos
                y servicios.
                <br />
                <sup>2</sup> Queja: Disconformidad no relacionada a los
                productos o servicios; o, malestar o descontento respecto a la
                atención al público.
              </p>
              <div className="form-rowRec">
                <div className="form-groupRec">
                  <label htmlFor="detalle">Detalle:</label>
                  <textarea
                    id="detalle"
                    name="detalle"
                    value={formData.detalle}
                    onChange={handleInputChange}
                    placeholder="Ingrese el detalle de la reclamación o queja"
                    rows="4"
                  ></textarea>
                </div>
              </div>
              <div className="form-rowRec">
                <div className="form-groupRec">
                  <label htmlFor="pedido">Pedido:</label>
                  <textarea
                    id="pedido"
                    name="pedido"
                    value={formData.pedido}
                    onChange={handleInputChange}
                    placeholder="Ingrese el pedido del consumidor"
                    rows="4"
                  ></textarea>
                </div>
              </div>
              {/* Parte 4: Observaciones Proveedor */}
              <h2>4. Observaciones y acciones adoptadas por el proveedor</h2>

              <div className="form-rowRec">
                <div className="form-groupRec">
                  <textarea
                    id="obsProveedor"
                    name="obsProveedor"
                    value={formData.obsProveedor}
                    placeholder="Este campo será llenado por el proveedor al momento de atender su queja o reclamo"
                    rows="4"
                    disabled /* Desactiva el textarea */
                  ></textarea>
                </div>
              </div>
              <div className="form-rowRec botones">
                <button type="submit" className=" buttonEnvíoyDescarga">
                  Guardar/Enviar
                </button>
                <button
                  type="button"
                  className="buttonCancelaryNuevoRegistro"
                  onClick={handleCancelar}
                >
                  Cancelar
                </button>
              </div>
            </form>

            <p className="disclaimer-text">
              <em>
                Primus Capital Perú S.A.C con RUC N° 20602253873, Primus Capital
                Créditos S.A.C. con RUC 20604262250, Primus Capital
                Administradora de Activos S.A.C. con RUC 20608121065, Primus
                Capital Leasing S.A.C. con RUC 20607258245, domiciliados en
                Av.Jorge Basadre 233, Piso 5, San Isidro, Lima, Perú, son los
                titulares del Banco de Datos Personales denominado “Libro de
                Reclamaciones”. De conformidad con el artículo 18° de la Ley de
                Protección de Datos Personales le informamos que sus datos serán
                tratados por nuestro personal a efectos de atender su reclamo o
                queja. Para más información respecto al tratamiento de sus datos
                personales sírvase ingresar a nuestra Política de Privacidad. En
                caso quisiera ejercer sus derechos de acceso, rectificación,
                cancelación, oposición, información, revocación y portabilidad,
                sírvase llenar el siguiente Formulario de Atención de Derechos
                ARCO. Cabe indicar que los datos personales que usted
                proporciona en el presente formulario (que podrían contener
                datos sensibles) serán utilizados y/o tratados por Primus
                Capital Perú S.A.C, Primus Capital
                Créditos S.A.C., Primus Capital
                Administradora de Activos S.A.C. y Primus
                Capital Leasing S.A.C., estricta y únicamente con la finalidad
                de realizar las actividades conducentes a atender su reclamo.
              </em>
            </p>
            <p className="disclaimer-text">
              <em>
                * La formulación del reclamo no impide acudir a otras vías de
                solución de controversias ni es requisito previo para interponer
                una denuncia ante el INDECOPI.
              </em>
            </p>
            <p className="disclaimer-text">
              <em>
                * El proveedor debe dar respuesta al reclamo o queja en un plazo
                no mayor a quince (15) días hábiles, el cual es improrrogable.{" "}
              </em>
            </p>
          </>
        ) : (
          <div className="resumen-container">
            <h3>Su número de reclamación registrada es: {idReclamacion}</h3>
            <div className="resumen">
              <p>
                <strong>Razón Social:</strong> {formData.razonSocial}
              </p>
              <p>
                <strong>1. Identificación del Consumidor Reclamante:</strong>
              </p>
              <p>
                <strong>Nombres:</strong> {formData.nombres}
              </p>
              <p>
                <strong>Apellidos:</strong> {formData.apellidos}
              </p>
              <p>
                <strong>Tipo de Documento:</strong> {formData.tipoDocumento}
              </p>
              <p>
                <strong>Número de Documento:</strong> {formData.numeroDocumento}
              </p>
              <p>
                <strong>Domicilio:</strong> {formData.domicilio}
              </p>
              <p>
                <strong>Correo Electrónico:</strong> {formData.correo}
              </p>
              <p>
                <strong>Teléfono:</strong> {formData.telefono}
              </p>
              <p>
                <strong>Es Menor de Edad:</strong>{" "}
                {formData.esMenorDeEdad ? "Sí" : "No"}
              </p>
              {formData.esMenorDeEdad && (
                <>
                  <p>
                    <strong>Nombre del Apoderado:</strong>{" "}
                    {formData.nombreApoderado}
                  </p>
                  <p>
                    <strong>Domicilio del Apoderado:</strong>{" "}
                    {formData.domicilioApoderado}
                  </p>
                  <p>
                    <strong>Teléfono del Apoderado:</strong>{" "}
                    {formData.telefonoApoderado}
                  </p>
                  <p>
                    <strong>Correo del Apoderado:</strong>{" "}
                    {formData.correoApoderado}
                  </p>
                </>
              )}
              <p>
                <strong>2. Identificación del bien contratado:</strong>
              </p>
              <p>
                <strong>Tipo de Bien:</strong> {formData.tipoBien}
              </p>
              <p>
                <strong>Monto del Bien Contratado:</strong> {formData.montoBien}
              </p>
              <p>
                <strong>Descripción:</strong> {formData.descripcion}
              </p>
              <p>
                <strong>
                  3. Detalle de la Reclamación y Pedido del Consumidor:
                </strong>
              </p>
              <p>
                <strong>Tipo de Reclamo:</strong> {formData.tipoReclamo}
              </p>
              <p>
                <strong>Detalle:</strong> {formData.detalle}
              </p>
              <p>
                <strong>Pedido:</strong> {formData.pedido}
              </p>

              <div className="form-rowRec botones-descarga-nvo">
                <button
                  className="buttonEnvíoyDescarga"
                  onClick={handleDescargarPDF}
                >
                  Descargar PDF
                </button>
                <button
                  className="buttonCancelaryNuevoRegistro"
                  onClick={handleCancelar}
                >
                  Nuevo Registro Reclamo / Queja
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LibroReclamaciones;
